// extracted by mini-css-extract-plugin
export default {"title":"HotelTickets_title__pyrM3","ticketsList":"HotelTickets_ticketsList__Enwoh","downloadTickets":"HotelTickets_downloadTickets__KaElt","spinner":"HotelTickets_spinner__sZgmG"};